import Transfer from './src/Transfer.vue'

/* istanbul ignore next */
Transfer.install = function (app) {
  app.component(Transfer.name, Transfer)
}

export default Transfer
